export const VITALS_METRICS_KEY = 'selectedVitalsMetrics';
export const CLINICAL_METRICS_KEY = 'selectedClinicalMetrics';
export const QUESTIONNAIRE_HIDDEN_SERIES_KEY = 'hiddenQuestionnaireSeries';
export const JOURNALS_METRICS_KEY = 'selectedJournalsMetrics';
export const JOURNAL_CATEGORIES_KEY = 'selectedJournalCategories';
export const TIME_INTERVAL_KEY = 'timeInterval';
export const LAB_METRIC_KEY = 'selectedLabMetric'; // Deprecated - keeping for migration
export const PK_BIOMARKERS_KEY = 'selectedPkBiomarkers';
export const EXTERNAL_BIOMARKERS_KEY = 'selectedExternalBiomarkers';
export const DATE_RANGE_PRESET_KEY = 'dateRangePreset';
export const CUSTOM_DATE_RANGE_KEY = 'customDateRange';

export const DEFAULT_START_TIME = '09:00';
export const DEFAULT_END_TIME = '14:00';

export const saveSelectedMetrics = (key: string, metrics: string[]) => {
  try {
    localStorage.setItem(key, JSON.stringify(metrics));
  } catch (error) {
    console.error('Error saving metrics to localStorage:', error);
  }
};

export const getSelectedMetrics = (key: string): string[] => {
  try {
    const savedMetrics = localStorage.getItem(key);
    return savedMetrics ? JSON.parse(savedMetrics) : [];
  } catch (error) {
    console.error('Error reading metrics from localStorage:', error);
    return [];
  }
};

export const saveTimeInterval = (startTime: string, endTime: string) => {
  try {
    localStorage.setItem(TIME_INTERVAL_KEY, JSON.stringify({ startTime, endTime }));
  } catch (error) {
    console.error('Error saving time interval to localStorage:', error);
  }
};

export const getTimeInterval = () => {
  try {
    const savedInterval = localStorage.getItem(TIME_INTERVAL_KEY);
    if (savedInterval) 
      return JSON.parse(savedInterval);
    
    return { startTime: DEFAULT_START_TIME, endTime: DEFAULT_END_TIME };
  } catch (error) {
    console.error('Error reading time interval from localStorage:', error);
    return { startTime: DEFAULT_START_TIME, endTime: DEFAULT_END_TIME };
  }
};

export const saveSelectedLabMetric = (metricId: string | null) => {
  try {
    localStorage.setItem(LAB_METRIC_KEY, JSON.stringify(metricId));
  } catch (error) {
    console.error('Error saving lab metric to localStorage:', error);
  }
};

export const getSelectedLabMetric = (): string | null => {
  try {
    const savedMetric = localStorage.getItem(LAB_METRIC_KEY);
    return savedMetric ? JSON.parse(savedMetric) : null;
  } catch (error) {
    console.error('Error reading lab metric from localStorage:', error);
    return null;
  }
};

export const saveSelectedPkBiomarkers = (biomarkers: string[]) => {
  try {
    localStorage.setItem(PK_BIOMARKERS_KEY, JSON.stringify(biomarkers));
  } catch (error) {
    console.error('Error saving PK biomarkers to localStorage:', error);
  }
};

export const getSelectedPkBiomarkers = (): string[] => {
  try {
    const savedBiomarkers = localStorage.getItem(PK_BIOMARKERS_KEY);
    return savedBiomarkers ? JSON.parse(savedBiomarkers) : [];
  } catch (error) {
    console.error('Error reading PK biomarkers from localStorage:', error);
    return [];
  }
};

export const saveSelectedExternalBiomarkers = (biomarkers: string[]) => {
  try {
    localStorage.setItem(EXTERNAL_BIOMARKERS_KEY, JSON.stringify(biomarkers));
  } catch (error) {
    console.error('Error saving external biomarkers to localStorage:', error);
  }
};

export const getSelectedExternalBiomarkers = (): string[] => {
  try {
    const savedBiomarkers = localStorage.getItem(EXTERNAL_BIOMARKERS_KEY);
    return savedBiomarkers ? JSON.parse(savedBiomarkers) : [];
  } catch (error) {
    console.error('Error reading external biomarkers from localStorage:', error);
    return [];
  }
};

export const saveDateRangePreset = (preset: string) => {
  try {
    localStorage.setItem(DATE_RANGE_PRESET_KEY, JSON.stringify(preset));
  } catch (error) {
    console.error('Error saving date range preset to localStorage:', error);
  }
};

export const getDateRangePreset = (): string | null => {
  try {
    const savedPreset = localStorage.getItem(DATE_RANGE_PRESET_KEY);
    return savedPreset ? JSON.parse(savedPreset) : null;
  } catch (error) {
    console.error('Error reading date range preset from localStorage:', error);
    return null;
  }
};

export const saveCustomDateRange = (range: [Date | null, Date | null]) => {
  try {
    localStorage.setItem(CUSTOM_DATE_RANGE_KEY, JSON.stringify(range));
  } catch (error) {
    console.error('Error saving custom date range to localStorage:', error);
  }
};

export const getCustomDateRange = (): [Date | null, Date | null] => {
  try {
    const savedRange = localStorage.getItem(CUSTOM_DATE_RANGE_KEY);
    if (savedRange) {
      const parsed = JSON.parse(savedRange);
      return [parsed[0] ? new Date(parsed[0]) : null, parsed[1] ? new Date(parsed[1]) : null];
    }
    return [null, null];
  } catch (error) {
    console.error('Error reading custom date range from localStorage:', error);
    return [null, null];
  }
}; 